import { useForm, UseFormProps, FormProvider, useWatch } from 'react-hook-form';
import FormCommentReviewFooter from './FormCommentReviewFooter';
import FormCommentReviewHeader from './FormCommentReviewHeader';
import FormCommentReviewBody from './FormCommentReviewBody';
import { FormLabelErrorMessage } from '@/components/forms';
import { DEFAULT_FORM_CONFIG } from '@/constants';
import { VerificationStateEnum } from '@/enums';
import { TFormData } from '.';

type TProps = {
  onSubmit: (state: VerificationStateEnum, comment: string) => Promise<void>;
  state?: VerificationStateEnum;
  comment?: string;
};

const VARIABLES = {
  formConfig: {
    ...DEFAULT_FORM_CONFIG,
    defaultValues: {
      state: VerificationStateEnum.OTHERS,
      comment: ''
    }
  } as UseFormProps<TFormData>
};

const FormCommentReview = ({ onSubmit, state = VerificationStateEnum.OTHERS, comment = '' }: TProps) => {

  const formMethods = useForm<TFormData>({ ...VARIABLES.formConfig, values: { comment, state } });
  const errorMessage = useWatch({ control: formMethods.control, name: 'errorMessage' });

  return (
    <FormProvider {...formMethods}>
      <FormCommentReviewHeader />
      <FormCommentReviewBody />
      <FormLabelErrorMessage errorMessage={errorMessage} />
      <FormCommentReviewFooter onSubmit={onSubmit} />
    </FormProvider>
  );

};

export default FormCommentReview;
